'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var canUseDOM = exports.canUseDOM = !!(
/* eslint-disable no-undef */
typeof window !== 'undefined' && window.document && window.document.createElement);